module.exports = __webpack_public_path__ + "static/media/wb.776a4c64.svg";